import { useMemo } from 'react';

import {
  type FilterDefinition,
  createEnumFilter,
} from '@spotify/confidence-core-react';

export const RESOURCE_TYPE_FILTER_ID = 'resourceType';

export const useCollectionTypeFilter = (
  availableTypes: string[],
): FilterDefinition | undefined =>
  useMemo(() => {
    if (availableTypes.length <= 1) return undefined;
    return createEnumFilter({
      id: RESOURCE_TYPE_FILTER_ID,
      label: 'Type',
      field: 'resourceType',
      enum: availableTypes,
    });
  }, [availableTypes]);
